package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun PageContext4Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/PageContext4.md", mapOf())) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("page-context") }) {
                org.jetbrains.compose.web.dom.Text("Page Context")
            }
            UrlBar("mysite.com/users/[{user}]/posts/[{post}]", id = "url")
            dev.bitspittle.droidconSf24.components.widgets.Code("""@Page("{}")
@Composable
fun PostPage() {
    val ctx = rememberPageContext()
    
    val userName = ctx.route.params.getValue("user").toInt()
    val postId = ctx.route.params.getValue("post").toInt()
    
    /* ... */
}
""", "kotlin 4,6,7 [code]")
        }
    }
}
